import { create } from 'zustand';
import type { IntegrationStateDto } from '@ecom/contracts';
import { adminApi, errorMessage, withSession } from '@/lib/api-client';

/**
 * Third-party services (ADR-029).
 *
 * The same shape as the payments store, because it is the same problem: a
 * catalogue from the API, secrets that are written and never read back.
 */
interface IntegrationsState {
  integrations: IntegrationStateDto[];
  loading: boolean;
  saving: boolean;
  error: string | null;

  load: () => Promise<void>;
  update: (key: string, patch: { enabled?: boolean; values?: Record<string, string> }) => Promise<boolean>;
}

export const useIntegrationsStore = create<IntegrationsState>((set) => ({
  integrations: [],
  loading: false,
  saving: false,
  error: null,

  async load() {
    set({ loading: true, error: null });

    try {
      const page = await withSession(() => adminApi.integrations.list());
      set({ integrations: page.items, loading: false });
    } catch (error) {
      set({ loading: false, error: errorMessage(error, 'Could not load the integrations.') });
    }
  },

  async update(key, patch) {
    set({ saving: true, error: null });

    try {
      const page = await withSession(() => adminApi.integrations.update(key, patch));
      set({ integrations: page.items, saving: false });
      return true;
    } catch (error) {
      set({ saving: false, error: errorMessage(error, 'Could not save.') });
      return false;
    }
  },
}));
